import React, { useState } from "react";
import { Modal, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditModalContent from "./EditModalContent";

const IconGroup = ({
  ele,
  updateCallback,
  deleteCallback,
  greenhouseLabel,
  allCrops,
  allVarieties,
  allPlots,
  currentSite,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleEditCancel = () => {
    setEditModalOpen(false);
  };
  const handleDelete = () => {
    deleteCallback(ele.id);
  };
  return (
    <div className="flex items-center">
      <EditOutlined
        className="pr-2 cursor-pointer text-primaryBlue"
        onClick={() => setEditModalOpen(true)}
      />
      <Popconfirm
        title={"Are you sure you want to delete this " + greenhouseLabel + "?"}
        onConfirm={handleDelete}
        okText="Yes"
        cancelText="No"
        placement="topRight"
      >
        <DeleteOutlined className="cursor-pointer text-dangerRed" />
      </Popconfirm>
      <Modal
        maskClosable={false}
        title={
          <div className="mb-5 font-IBMPlexSansBold text-2xl">
            Edit {greenhouseLabel}
          </div>
        }
        open={editModalOpen}
        onCancel={handleEditCancel}
        footer={null}
      >
        <EditModalContent
          setOpen={setEditModalOpen}
          data={ele}
          updateCallback={updateCallback}
          allCrops={allCrops}
          allPlots={allPlots}
          allVarieties={allVarieties}
          greenhouseLabel={greenhouseLabel}
          currentSite={currentSite}
        />
      </Modal>
    </div>
  );
};

export default IconGroup;
